import { Navigate, useParams } from "react-router-dom";

/**
 * Backwards-compat redirect for old `/bookings/:id` deep links. The
 * panel now lives at `/bookings?focus=<id>` (matches Clients).
 */
export function BookingDetail() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/bookings" replace />;
  return <Navigate to={`/bookings?focus=${id}`} replace />;
}
